import { useState, useEffect } from 'react';

export function useHeaderHeight() {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const header = document.querySelector('header');
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeight();
    
    // Create an observer to track height changes (e.g. mobile menu toggle, resizing)
    const resizeObserver = new ResizeObserver(updateHeight);
    const header = document.querySelector('header');
    if (header) {
      resizeObserver.observe(header);
    }

    window.addEventListener('resize', updateHeight);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return headerHeight;
}
